<template>
  <v-container>
  <h2>Alocações</h2>
  <h3>em desenvolvimento...</h3>  
  </v-container>
  
</template>

<script>
export default {

}
</script>

<style scoped>

</style>